import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    width: 100%;
    background-color: #DAE4F0;
`;

export const Content = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`;

export const Title = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    font-size : 1em;
    padding: 10px 5px;

    text-align: justify;
    text-justify: inter-word;
`;

export const Text = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size : 0.8em;
    padding: 7px 5px;

    text-align: justify;
    text-justify: inter-word;
`;

export const Row = styled.div`
    display: flex;
    margin-bottom: 5px;
    position: relative;
`;

export const ButtonArea = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
`;

export const Button = styled.button`
    margin: auto;
    border: none;
    background: none;
    background-color: #385799;
    color: white;

    border-radius: 7px;

    padding: 4px 15px;
    margin-top: 10px;
    margin-bottom: 10px;
    cursor: pointer;
`;

export const ModalMessage = styled.span`
    
`;

export const ErrorMessage = styled.span`
    white-space: pre-wrap;
    color: ${props => props.state ? "green": "red"};
`;